module.exports = __webpack_public_path__ + "static/img/xzam.44c4a66d.png";